import { combineReducers } from 'redux';

import isLoading from './isLoading';
import isVisible from './isVisible';

/**
 * @typedef {{
 *  isLoading : import('./isLoading').State;
 *  isVisible : import('./isVisible').State;
 * }} ApproveManuallyState
 */
export default combineReducers({
  isLoading,
  isVisible,
});
